// Липкая шапка лендинга: фон с блюром показываем только когда страница прокручена
// (см. .header--scrolled в _header.scss) — в самом верху шапка прозрачная. Как в ЛК (Header.vue).
export function initHeaderScroll() {
  const header = document.getElementById('landingHeader');
  if (!header) return;

  const update = () => {
    header.classList.toggle('header--scrolled', window.scrollY > 0);
  };

  window.addEventListener('scroll', update, { passive: true });
  // Страница может открыться уже прокрученной (якорь, восстановление позиции после перезагрузки).
  update();
}
